"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaymentMethod = void 0;
var typeAdapters_1 = require("./typeAdapters");
var constants_1 = require("./constants");
var util_1 = require("./util");
function createPaymentMethod(paymentMethod, config) {
    var payload = typeAdapters_1.buildCreatePaymentMethodPayload(paymentMethod);
    return fetch(config.embedApiBaseUrl + "/payment/payment-methods", {
        method: 'POST',
        headers: constants_1.CLIENT_HEADERS,
        body: JSON.stringify(payload),
    })
        .then(function (response) { return util_1.parseResponse(response, { throwErrors: true }); })
        .then(function (response) { return typeAdapters_1.buildCreatePaymentMethodResult(response); });
}
exports.createPaymentMethod = createPaymentMethod;
